export default __webpack_public_path__ + "static/media/Branding.b5597876.png";